<template>
  <div class="dashboard">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex sm12 md6>
          <v-card
            class="mt-3 mx-auto pt-3"
            max-width="800"
            elevation="12"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="grey darken-4"
              elevation="3"
              max-width="calc(100% - 32px)"
            >
              <v-sparkline
                :labels="lastTenDays"
                :value="lastTenDays"
                :gradient="['#FF2222', '#FBC02D']"
                :color="'#FBC02D'"
                line-width="3"
                padding="15"
                smooth
                auto-draw
                :auto-draw-duration="1000"
              ></v-sparkline>
            </v-sheet>

            <v-card-text class="pt-3">
              <div class="title font-weight-light mb-2">Number of Submissions</div>
              <div class="subheading font-weight-light grey--text">Last 10 days</div>
              <v-divider class="my-2"></v-divider>
              <v-icon
                class="mr-2"
                small
              >
                schedule
              </v-icon>
              <span class="caption grey--text font-weight-light">latest submission {{ latestSubmission }}</span>
            </v-card-text>

          </v-card>
        </v-flex>

        <v-flex sm12 md6>
          <v-card
            class="mt-3 mx-auto pt-3"
            max-width="800"
            elevation="12"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="grey darken-4"
              elevation="3"
              max-width="calc(100% - 32px)"
            >
              <v-sparkline
                :labels="monthlyValues"
                :value="monthlyValues"
                :gradient="['#FBC02D', '#FF2222']"
                :color="'#FBC02D'"
                line-width="3"
                padding="15"
                smooth
                auto-draw
                :auto-draw-duration="1000"
                type="bar"
              ></v-sparkline>
            </v-sheet>

            <v-card-text class="pt-3">
              <div class="title font-weight-light mb-2">Submissions this month</div>
              <div class="subheading grey--text font-weight-light">{{ thisMonthText()  }}</div>
              <v-divider class="my-2"></v-divider>
              <v-icon
                class="mr-2"
                small
              >
                poll
              </v-icon>
              <span class="caption grey--text font-weight-light">{{ getMonthlyTotal() }} in total</span>
            </v-card-text>
          </v-card>
        </v-flex>

         <v-flex sm12 md6>
          <v-card
            class="mt-2 mx-auto px-3 py-3"
            max-width="800"
            elevation="12"
          >
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-card 
                  color="grey darken-4"
                  :to="'/appointments'"
                  hover
                >
                  <v-card-title>
                    <v-layout class="px-3 py-3" justify-center align-center column>
                    <div class="num-appointments display-3 font-weight-thin">{{ calcNumUpcomingAppointments }}</div>
                    
                    <h2 class="headline text-xs-center"><v-icon class="mr-2">alarm_on</v-icon>Appointments
                      <div class="subheading grey--text font-weight-light" style="line-height:18px;">upcoming</div>
                    </h2>
                    </v-layout>
                  </v-card-title>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6>
                <v-card 
                  color="grey darken-4"
                  :to="'/submissions'"
                  hover
                >
                  <v-card-title>
                    <v-layout class="px-3 py-3" justify-center align-center column>
                      <div class="num-appointments display-3 font-weight-thin">{{ submissions.length }}</div>
                      <h2 class="headline text-xs-center"><v-icon class="mr-2">drive_eta</v-icon>Submissions
                      <div class="subheading grey--text font-weight-light" style="line-height:18px;">in total</div>
                      </h2>
                    </v-layout> 
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'

export default {
  data() {
    return {
     
     
    }
  },
  computed: {
    appointments() {
      return this.$store.getters.appointments
    },
    submissions() {
      return this.$store.getters.submissions
    },
    calcNumUpcomingAppointments() {
      let today = moment().format('YYYY-MM-DD')
      let num = 0;
      this.appointments.forEach(item => {
        if(item.date > today)
          num++
      })
      return num
    },
    latestSubmission() {
      return moment(this.submissions[this.submissions.length-1].created).from(moment())
    },
    monthlyValues() {
      return this.latestValues(parseInt( moment().format('D') ), true)
    },
    lastTenDays() { 
      return this.latestValues(10, false)
    }
    
  },
  methods: {
    thisMonthText() {
      return moment().format('MMMM')+' '+moment().format('YYYY')
    },
    getMaxKey(obj) {
      return Math.max.apply(null,Object.keys(obj))
    },
    getMonthlyTotal() {
      return this.monthlyValues.reduce((partial_sum, a) => partial_sum + a); 
    },
    latestValues(duration, monthly) {

      
      let tsToday = moment()
      
      let tsStart = moment().subtract(duration-1, 'days')
      
      let arrayOfDates = []
      this.submissions.forEach(item => {
        if(item.created >= tsStart && item.created <= tsToday ) {
          let date = parseInt( moment(item.created).format('D') )
          arrayOfDates.push(date)
          
        }
      })
      
      let counts = {}
      arrayOfDates.forEach(day => {
        counts[day] = (counts[day] || 0)+1
      })

      let values = []
      if(!monthly){ 
        
        //console.log(counts) 
        for(let i=0; i < duration; i++) {
          //first dat will be tsStart
          if(i==0){
            var check = parseInt( moment(tsStart).format('D') )
          }else{
            var check = parseInt( moment(tsStart).add(i, 'days').format('D') )
          }
          //console.log(check)
          values[i] = (check in counts) ? counts[check]  : 0
        }
        return values
        
      }
      
      let highestDay = this.getMaxKey(counts)
      
      for (let i = 0; i < highestDay; i++) {
        let check = (i+1).toString()
        values[i] = (check in counts) ? counts[check]  : 0
      }
     
      return values
    }
  }
};
</script>
